import React from "react";
import { Box } from "@mui/material";
import { pxToRem } from "../../../../utils/fontSizeUtility";

interface LoanNumberProps {
  loanNumber?: string;
}

export const LoanNumber = (props: LoanNumberProps) => {
  return (
    <>
      {props.loanNumber && (
        <Box
          sx={{
            border: 1,
            paddingX: pxToRem(8),
            paddingY: pxToRem(4),
            marginTop: pxToRem(8),
            marginLeft: pxToRem(24),
            width: "fit-content",
            fontSize: "12px",
            color: "info.main",
            backgroundColor: "info.light",
          }}
        >
          Loan #{props.loanNumber}
        </Box>
      )}
    </>
  );
};
